<script>
export default {
	props: {
		data: Object,
		index: Number,
	},

	computed: {
		listId() {
			return `${this.data.collectionId}-${this.data.title}`
		},

		btnHoverCard() {
			let productCard = this.$srv('productCardType', {})
			if (this.$b.d) return productCard.btnDesktop == 'btnHover'
			return false
		},

		imgBoard() {
			return this.data.boardEnabled && this.data.boardType == 'img'
		},

		bgBoard() {
			if (this.data.boardEnabled && this.data.boardType == 'bg')
				return this.data.bgTitle || this.data.bgSubtitle || this.limitedTimeOffer
			else return false
		},

		productBoard() {
			return this.data.boardEnabled && this.data.boardType == 'product'
		},

		rowClass() {
			if (this.$b.d) {
				if (!this.data.inverted) {
					if (this.data.boardEnabled && this.data.boardType != 'img') return 'row'
					else return 'd-flex flex-row align-md-center px-md-3 mt-3'
				} else {
					if (this.data.boardEnabled && this.data.boardType != 'img') return 'row flex-row-reverse'
					else return 'd-flex flex-row-reverse align-md-center px-md-3 mt-3'
				}
			} else {
				if (!this.data.inverted) {
					return 'd-flex flex-column align-center px-md-3 mt-3'
				} else {
					return 'd-flex flex-column-reverse align-center px-md-3 mt-3'
				}
			}
		},

		boardColumnClass() {
			let res
			if (this.productBoard) {
				if (this.data.inverted) res = 'mt-4'
				else res = 'mb-4'
			} else if (this.bgBoard) {
				if (this.$b.mt) {
					if (this.data.inverted) res = 'mt-4 pa-0'
					else res = 'minHeighForBgColorMobile pa-0 mb-4'
				}
			}

			return res
		},

		imgBoardClass() {
			let res
			if (this.data.inverted) {
				res = 'pl-md-3'
				if (this.$b.mt) res = 'w100 mt-4'
			} else {
				res = 'pr-md-3'
				if (this.$b.mt) res = 'w100 mb-4'
			}

			if (this.$b.d) res += ' flex-shrink-0'

			return res
		},

		carouselConfig() {
			if (this.$b.d) {
				if (this.imgBoard) {
					// desktop with image
					let img_w = this.data.img.data.width
					if (img_w <= 300) {
						return { slidesPerPage: 3, gutter: 20, peekRight: 0 }
					} else if (img_w <= 360) {
						return { slidesPerPage: 2, gutter: 20, peekRight: 220 }
					} else {
						return { slidesPerPage: 2, gutter: 20, peekRight: 170 }
					}
				} else if (this.productBoard || this.bgBoard) {
					// desktop with product or color
					return { slidesPerPage: 3, gutter: 20, peekRight: 0 }
				} else {
					// desktop without image
					return { slidesPerPage: 4 }
				}
			} else if (this.$b.t) {
				// tablet
				return { slidesPerPage: 3 }
			} else {
				// mobile
				return { slidesPerPage: 2, gutter: 10 }
			}
		},

		bgColor() {
			if (this.bgBoard) {
				return { backgroundColor: this.data.bgColor }
			} else return null
		},

		textPosition() {
			switch (this.data.bgTextPosition) {
				case 'top':
					return 'justify-start pt-4'

				case 'mid':
					return 'justify-center'

				default:
					return 'justify-end pb-4'
			}
		},

		limitedTimeOffer() {
			let offer = this.$store.get('shop/limitedTimeOffer')
			if (this.productBoard) {
				return offer?.find((item) =>
					this.data.boardProduct.collectionsIds.find((el) => item.collectionId == el)
				)
			} else return offer?.find((el) => el.collectionId == this.data.collectionId)
		},

		limitedTimeOfferDate() {
			const date = this.limitedTimeOffer?.untilDate

			const fecha = new Date(date).toLocaleDateString('es-AR', {
				day: 'numeric',
				month: 'long',
				timeZone: 'UTC',
			})
			return `La oferta termina el ${fecha}`
		},
	},

	mounted() {
		if (this.data.products?.length) {
			this.$eventer().trigger('product-list:view', {
				products: this.data.products,
				listId: this.listId,
			})
		}
	},
}
</script>

<template>
	<Container
		v-if="data.products && data.products.length"
		:fluid="$b.m"
		class="align-center"
		:class="[
			$bem('enhanced-products-carousel'),
			{
				'p-relative': imgBoard && btnHoverCard,
			},
		]"
	>
		<Title
			v-if="data.textEnabled"
			:title="data.title"
			:btn="{ link: data.link, linkText: data.linkText }"
			:titleStyle="data.titleStyle"
		/>

		<div :class="[rowClass, { 'p-relative': data.boardEnabled && btnHoverCard }]">
			<!-- BOARD -->
			<v-col
				class="justify-center d-flex"
				:class="[
					{
						'col-3': $b.d,
						'col-12': $b.m,
						'col-11': $b.t,
					},
					boardColumnClass,
				]"
				v-if="productBoard || bgBoard"
			>
				<!-- ProductCard board -->
				<div :class="{ w100: !$b.t }" v-if="productBoard">
					<ProductCard
						:product="data.boardProduct"
						:list-id="listId"
						:verticalCard="$b.mt ? false : true"
						featured
						:timerProduct="limitedTimeOffer ? true : false"
						:position="data.inverted ? 'left' : 'right'"
					/>
				</div>

				<!-- BGColor board -->
				<SafeLink
					v-if="bgBoard"
					:to="data.bgLink"
					class="w100"
					:style="bgColor"
					:class="{ 'rounded-lg': $b.d }"
				>
					<div
						class="d-flex flex-column align-center h100 w100 px-6"
						:class="[
							{ 'background-overlay': data.bgImgOverlay, 'rounded-lg': $b.d },
							textPosition,
							$b.mt ? 'py-10' : 'py-4',
						]"
					>
						<div class="d-flex flex-column align-center">
							<h3
								class="font-weight-bold line-clamp-3 strong"
								:class="{ 'font-4': $b.mt, 'font-5 mb-1': $b.d }"
								v-if="data.bgTitle"
							>
								{{ data.bgTitle }}
							</h3>

							<p
								v-if="data.bgSubtitle"
								class="font-weight-medium line-clamp-3 primary"
								:class="{ 'mb-1 font-2': $b.mt, 'font-3 mb-3': $b.d }"
							>
								{{ data.bgSubtitle }}
							</p>
						</div>

						<div v-if="limitedTimeOffer">
							<LimitedTimeOfferCountdown :limitedTimeOffer="limitedTimeOffer" timerCard />
							<div class="mt-2">
								<p
									class="text-uppercase line-clamp-3 mb-0 font-weight-medium secondary py-1 px-2 rounded font-0 text-center"
								>
									{{ limitedTimeOfferDate }}
								</p>
							</div>
						</div>
					</div>
				</SafeLink>
			</v-col>
			<!-- Image board -->
			<div v-if="imgBoard" :class="imgBoardClass">
				<SafeLink :to="data.bgLink">
					<Media
						:src="$b.mt ? data.imgMobile : data.img"
						class="h100 w100"
						:img-class="$b({ d: 'rounded-lg' })"
						:width="$b.mt && '100%'"
					>
						<div
							class="d-flex flex-column align-center h100 w100 px-6"
							:class="[
								{ 'rounded-lg': $b.d },
								data.bgImgOverlay && 'background-overlay',
								textPosition,
							]"
						>
							<div class="d-flex flex-column align-center">
								<h3
									class="font-weight-bold line-clamp-3 strong"
									:class="{ 'font-4': $b.mt, 'font-5 mb-2': $b.d }"
									v-if="data.bgTitle"
								>
									{{ data.bgTitle }}
								</h3>

								<p
									v-if="data.bgSubtitle"
									class="font-weight-medium line-clamp-3 primary--text"
									:class="{ 'mb-1 font-2': $b.mt, 'font-3 mb-0': $b.d }"
								>
									{{ data.bgSubtitle }}
								</p>
							</div>

							<div v-if="limitedTimeOffer">
								<LimitedTimeOfferCountdown :limitedTimeOffer="limitedTimeOffer" timerCard />
								<div class="mt-2">
									<p
										class="text-uppercase line-clamp-3 mb-0 font-weight-medium secondary py-1 px-2 rounded font-0 text-center"
									>
										{{ limitedTimeOfferDate }}
									</p>
								</div>
							</div>
						</div>
					</Media>
				</SafeLink>
			</div>

			<!-- PRODUCTS CAROUSEL -->
			<div
				class="w100 no-mobile-px"
				style="min-width: 0; align-self: center"
				:class="{
					'col pa-0': data.boardEnabled && data.boardType != 'img' && $b.d,
					'enhanced-products-carousel__btnHoverFix': $b.d && data.boardEnabled && btnHoverCard,
				}"
			>
				<ProductsCarousel
					:products="data.products"
					:list-id="listId"
					v-bind="carouselConfig"
					:dotContainerFullWidthMobile="
						Math.round(data.products.length / carouselConfig.slidesPerPage) >= 15
					"
					:arrowsBgHalfRounded="!data.imgEnabled"
				/>
			</div>
		</div>
	</Container>
</template>

<style scoped lang="scss">
.enhanced-products-carousel {
	&__btnHoverFix {
		top: 30px;
		position: relative;
	}
}

.background-overlay {
	background-color: #424242aa;
}

.minHeighForBgColorMobile {
	min-height: 300px;
}

::v-deep button.ssr-carousel-next-button {
	right: 1%;
}
::v-deep button.ssr-carousel-back-button {
	left: 1%;
}
</style>

